export default __webpack_public_path__ + "static/media/sprinz-logo.3c7ae8ff.svg";